<script>
export default {
  name: "semp-add",
  props: {
    semp: {
      visible: Boolean,
      operate: String,
      formData: {},
    },
    sempList: Array,
    mpcdList: Array
  },
  data() {
    return {
      rules: {
        mpcd: [
          { required: true, message: '请选择测点编号', trigger: 'blur' },
        ],
        tbbtX: [
          { required: true, message: '请输入管口X坐标', trigger: 'blur' },
        ],
        tbbtY: [
          { required: true, message: '请输入管口Y坐标', trigger: 'blur' },
        ],
        tbtpX: [
          { required: true, message: '请输入管底X坐标', trigger: 'blur' },
        ],
        tbtpY: [
          { required: true, message: '请输入管底Y坐标', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    init() {
      this.semp.formData.type = '0601';
      this.semp.formData.name = '测压管水位';
    },
    handleClose() {
      this.semp.index = undefined;
      this.semp.formData = {};
      this.semp.formData.type = '0601';
      this.semp.formData.name = '测压管水位';
      this.$refs["df"].clearValidate();
    },
    save() {
      this.$refs['df'].validate((valid) => {
        if (valid) {
          if (this.semp.index !== undefined) {
            this.sempList.splice(this.semp.index, 1, this.semp.formData)
          } else {
            this.sempList.push(this.semp.formData);
          }
          this.semp.visible = false;
        } else {
          return false
        }
      });
    },
    handleChange(val) {
      this.semp.formData.mpnm = this.mpcdList.find(_ => _.mpcd === val).mpnm;
    },
    numberInput(val) {
      let INTEGER_LENGTH = 5;
      let DECIMAL_LENGTH = 3;
      let str = val.replace('-', '');
      let intStr, decStr;

      // 判断是否是浮点数
      if (str.indexOf('.') === -1) {
        intStr = str;
      } else {
        let arr = str.split('.');
        intStr = arr[0];
        decStr = arr[1];
      }

      // 处理整数位
      if (intStr.length > INTEGER_LENGTH) {
        intStr = intStr.substr(0, INTEGER_LENGTH);
      }

      // 处理小数位
      if (decStr && decStr.length > DECIMAL_LENGTH) {
        decStr = decStr.substr(0, DECIMAL_LENGTH);
      }

      // 组合
      if (val.indexOf('-') === -1) {
        return decStr ? intStr + '.' + decStr : intStr;
      } else {
        return decStr ? '-' + intStr + '.' + decStr : '-' + intStr;
      }
    }
  },
  mounted() {
    this.init();
  },
}
</script>

<template>
  <el-dialog
      :visible.sync="semp.visible"
      :close-on-click-modal="false"
      width="25%"
      @close="handleClose"
      append-to-body>
    <div slot="title" class="header-title">
      <div class="dgTitle">{{ semp.title }}</div>
      <el-image class="dgImg2" :src="require('../../../assets/icons/dg-gb.png')" @click="semp.visible = false"></el-image>
    </div>
    <el-form ref="df" :model="semp.formData" :rules="rules">
      <el-col :span="24">
        <el-form-item label="监测项目" prop="name">
          <el-input v-model="semp.formData.name" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="测点编号" prop="mpcd">
          <el-select v-model="semp.formData.mpcd" style="width: 100%" placeholder="" @change="handleChange">
            <el-option
                v-for="item in mpcdList"
                :key="item.mpcd"
                :label="item.mpnm"
                :value="item.mpcd">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="管口X坐标" prop="tbbtX">
          <el-input v-model="semp.formData.tbbtX" type="number" @input="semp.formData.tbbtX = numberInput(semp.formData.tbbtX)"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="管口Y坐标" prop="tbbtY">
          <el-input v-model="semp.formData.tbbtY" type="number" @input="semp.formData.tbbtY = numberInput(semp.formData.tbbtY)"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="管底Y坐标" prop="tbtpY">
          <el-input v-model="semp.formData.tbtpY" type="number" @input="semp.formData.tbtpY = numberInput(semp.formData.tbtpY)"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="semp.visible = false" class="dgClose">关 闭</el-button>
        <template>
          <el-button
              slot="reference"
              type="primary"
              @click="save"
              class="dgSave">保 存
          </el-button>
        </template>
    </span>
  </el-dialog>
</template>

<style scoped>
.dgTitle{
  margin-left: 2vh;
  font-family: PingFang SC;
  font-size: 1.6vh;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vh;
  color: #323232;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
}

.dgImg2{
  position: absolute;
  right: 2vh;
  top:1.5vh;
  width: 3vh;
  height: 3vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.dgClose{
  width: 8vh;
  height: 3vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #0066ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid 1px #53abfd;
  border-radius: 2px;
}

.dgSave{
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}
</style>